<div class="camera-modal">

  <!-- HEADER -->
  <div class="camera-header" *ngIf="!isLandscape">
    <span class="title h3">Capture Photo</span>

    <button mat-icon-button mat-dialog-close
            (click)="closeModal()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- BODY -->
  <div class="camera-body">
    <!-- PREVIEW -->
    <div class="camera-preview"
         #cameraWrapper
         (touchstart)="onTouchStart($event)"
         (touchmove)="onTouchMove($event)">

      <video #video autoplay playsinline></video>
    </div>

    <!-- CONTROLS -->
    <div class="camera-controls">
      <div class="camera-header" *ngIf="isLandscape">
        <span class="title h3">Capture Photo</span>

        <button class="mb-3" mat-icon-button mat-dialog-close
                (click)="closeModal()">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <!-- zoom -->
      <input type="range"
             min="1"
             max="4"
             step="0.1"
             [value]="zoomLevel"
             (input)="zoomLevel = $any($event.target).value; onZoomSliderChange()" />

      <!-- action row -->
      <div class="capture-row">
        <button mat-stroked-button id="snap" color="secondary" (click)="startCamera()">
          Retake
        </button>

        <button *ngIf="!isTakePhoto"
                mat-raised-button id="snap"
                class="blue_button"
                (click)="capture()">
          Take Photo
        </button>

        <button *ngIf="isTakePhoto"
                mat-raised-button id="snap"
                class="blue_button"
                (click)="sendImage()">
          Use Photo
        </button>

        <button *ngIf="isLandscape"
                mat-raised-button class="blue_button"
                (click)="toggleCamera()">
          {{ toggleButtonText }}
        </button>
      </div>

      <button mat-raised-button class="blue_button" *ngIf="!isLandscape"
              (click)="toggleCamera()">
        {{ toggleButtonText }}
      </button>

    </div>

  </div>

  <canvas #canvas style="display:none;"></canvas>

</div>
